import { CorpusId, WidgetId } from '../models/aliases';
import { PaperReaction } from '../models/reactions';
import {
  useReactionsQuery,
  useSubmitTextFeedbackMutation,
  useUpdateReactionMutation,
} from '../store/endpoints/reactions';

import { useCallback } from 'react';

export interface ReactionData {
  reactions: Array<PaperReaction>;
  updateReaction: (pr: PaperReaction) => Promise<void>;
  submitTextFeedback: (corpusId: CorpusId, text: string) => Promise<void>;
}

export function useReactionsData(
  baseUrl: string,
  widgetId: WidgetId,
): ReactionData {
  const { data } = useReactionsQuery({ baseUrl, widgetId });
  const reactions = data ? data.reactions : [];

  const [update] = useUpdateReactionMutation();

  const updateReaction = useCallback(
    async (reaction: PaperReaction): Promise<void> => {
      await update({ baseUrl, widgetId, reaction }).unwrap();
    },
    [baseUrl, widgetId],
  );

  const [submit] = useSubmitTextFeedbackMutation();

  const submitTextFeedback = useCallback(
    async (corpusId: CorpusId, text: string): Promise<void> => {
      await submit({ baseUrl, widgetId, corpusId, text }).unwrap();
    },
    [baseUrl, widgetId],
  );

  return { reactions, updateReaction, submitTextFeedback };
}
